<template>
    <div class="vc-panel vcd" v-loading="showLoading" element-loading-text="加载中...">
        <!-- <img style="width: 100px;" src="@/assets/images/app_logo256.png" alt="应用Logo" /> -->

        <div class="loginbrd">
            <div class="inrect">
                <div class="color1" data-v-6fd59704="" style="font-size: 30px;font-weight: bold;margin-bottom: 30px;">
                    新用户注册</div>
                <div>
                    <div class="slab">邮箱地址</div>
                    <div class="minput-dv mgt10">
                        <SvgIcon fill="var(--ek-text-color2)" svgname="ic_account" class="sic"></SvgIcon>
                        <input type="text" v-model="account" placeholder="请输入邮箱地址" class="minput"
                            style="flex-grow: 1;width: 0px;" />
                    </div>
                </div>
                <div style="margin-top: 20px;">
                    <div class="slab">登录密码</div>
                    <div class="minput-dv mgt10">
                        <SvgIcon fill="var(--ek-text-color2)" :size="18" svgname="ic_password" class="sic"></SvgIcon>
                        <input type="password" v-model="password" placeholder="请输入登录密码" class="minput"
                            style="flex-grow: 1;width: 0px;" />
                    </div>
                </div>
                <div style="margin-top: 20px;">
                    <div class="slab">用户昵称</div>
                    <div class="minput-dv mgt10">
                        <SvgIcon fill="var(--ek-text-color2)" svgname="ic_edit1" :size="16" class="sic"></SvgIcon>
                        <input type="text" @keypress.enter="register" v-model="nickname" placeholder="请输入昵称"
                            class="minput" style="flex-grow: 1;width: 0px;margin-left:2px;" />
                    </div>
                </div>
                <div @click="register" class="bnt-login focus-s">立即注册</div>
                <div @click="goback" class="mlink bnt-reg focus-s">已有账号？返回登录</div>
            </div>
        </div>
    </div>
</template>

<script>
import SvgIcon from '@/components/SvgIcon.vue';
import httpClient from '@/commom/http/httpClient.js';
import localUser from '@/commom/local/LocalUser';
import browserHelper from '@/commom/browser/BrowserHelper.js';
export default {
    name: 'RegisterPage',
    components: {
        SvgIcon
    },
    props: {
        shareCode: {
            type: String,
            default: ''
        }
    },
    data() {
        return {
            account: "",
            password: "",
            nickname: "",
            showLoading: false
        }
    },
    mounted: function () {
        this.recordVisit()
    },
    methods: {
        ///记录访问者
        recordVisit: function () {
            if (this.shareCode == null || this.shareCode == "") {
                //没有分享码
                return
            }
            var req = {
                shareCode:this.shareCode,
                userAgent:browserHelper.getBrowserInfo()
            }
            httpClient.invoke("ShareAPI.RecordVisit",req,function(res){

            })
        },
        ///用户登录
        register: function () {
            var account = this.account.trim()
            var password = this.password.trim()
            var nickname = this.nickname.trim()
            if (account.length == 0) {
                this.$message.error("请输入邮箱地址")
                return
            }
            if (password.length == 0) {
                this.$message.error("请输入登录密码")
                return
            }
            if (nickname.length == 0) {
                this.$message.error("请输入用户昵称")
                return
            }
            var shareCode = ""
            if(this.shareCode != null && this.shareCode != ""){
                shareCode = this.shareCode
            }

            var req = {
                account: account,
                password: password,
                nickname: nickname,
                shareCode:shareCode
            }
            var that = this
            that.showLoading = true
            httpClient.invoke("UserAPI.Register", req, function (res) {
                console.log("返回结果", res)
                that.showLoading = false
                if (res.error) {
                    that.$message.error(res.error)
                    return
                }
                localUser.cacheUser(res)
                that.$message.success("注册成功")
                that.$router.replace("/main-page")
            })

        },
        ///返回登录
        goback: function () {
            this.$router.go(-1)
        },
        
    }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.bnt-reg {
    margin-top: 30px;
    text-align: center;
}

.bnt-login {
    margin-top: 40px;
    background: var(--ek-color-primary);
    color: white;
    text-align: center;
    line-height: 40px;
    border-radius: 5px;
}

.stitle {
    font-size: 30px;
    font-weight: bold;
    font-family: sans-serif;
    margin-top: 20px;
}

.slab {
    color: var(--ek-text-color2);
}

.minput {
    height: 40px;
    color: var(--ek-text-color1);
}

.inrect {
    margin-left: 70px;
    margin-right: 70px;
    margin-top: 30px;
}

.sic {
    margin-left: 15px;
    margin-right: 7px;
}

.minput-dv {
    background: var(--ek-input-backColor);
    height: 40px;
    display: flex;
    align-items: center;
    border-radius: 5px;
}

.vcd {
    justify-content: center;
    align-items: center;
}

.loginbrd {
    width: 500px;
    max-width: 90vw;
    max-height: 90vh;
    background: var(--ek-mainbody-bgcolor);
    border-radius: 15px;
    box-shadow: 5px 5px 5px #00000005;

    padding-bottom: 40px;
}

/* 针对不同屏幕尺寸的响应式调整 */
@media (max-width: 768px) {
    .loginbrd {
        width: 90%;
        /* 平板设备上使用90%宽度 */
        height: auto;
        /* 高度自适应 */
        min-height: 500px;
        /* 设置最小高度 */
    }

    .inrect {
        margin-left: 40px;
        margin-right: 40px;
        /* 平板设备上减小左右边距 */
    }
}

@media (max-width: 480px) {
    .loginbrd {
        width: 95%;
        /* 手机设备上使用95%宽度 */
        height: auto;
        /* 高度自适应 */
        min-height: 450px;
        /* 设置最小高度 */
        border-radius: 10px;
        /* 小屏幕上减小圆角 */
    }

    .inrect {
        margin-left: 20px;
        margin-right: 20px;
        /* 手机设备上进一步减小左右边距 */
        margin-top: 30px;
        /* 手机设备上略微减小上边距 */
    }
}
</style>
